import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutUserGroupList extends Layout {
    layoutheaderUserGroups: LayoutHeader;
    sourceUserGroupList: DataSource;
    tableGroups: Table;
}
